import styles from "./index.module.scss";

interface TextareaFieldProps {
    label: string;
    value: string;
    name: string;
    placeholder?: string;
    onChange: (name: string, value: string) => void;
}

const TextareaField = ({ label, value, name, placeholder, onChange }: TextareaFieldProps) => {
    const handleInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        onChange(name, e.target.value);
    };

    return (
        <div className={styles.textareaContainer}>
            <label htmlFor={name} className={styles.label}>{label}</label>
            <textarea
                value={value}
                onChange={handleInput}
                placeholder={placeholder}
                className={styles.textarea}
            />
        </div>
    );
};

export default TextareaField;